
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { configStore } from "@/store/store";
import { fpJsonStringify } from "@/util/fp-json-stringify";
import { pipe } from "fp-ts/function";
import { fold } from "fp-ts/Either";

@Component
export default class RichTextInputTinyMceDialog extends Vue {
  @Prop({ default: false })
  open!: boolean;

  @Prop()
  value!: string;

  loading = true;
  expanded = false;

  get tinyMceUrl() {
    if (configStore.neededData) {
      return configStore.neededData.tinyMceUrl;
    }
    return "";
  }

  @Watch("open", { immediate: true })
  onDialogUpdated() {
    if (this.open) {
      this.bindListeners();
      this.loading = true;
    } else {
      this.unbindListeners();
    }
  }

  beforeDestroy() {
    this.unbindListeners();
  }

  bindListeners() {
    document.addEventListener(
      "breakdanceTinyMceControlReady",
      this.onDialogReady
    );
    document.addEventListener(
      "breakdanceTinyMceControlInput",
      this.onTinyMceControlInput as EventListener
    );
    document.addEventListener("breakdanceTinyMceControlExpand", this.expand);
    document.addEventListener(
      "breakdanceTinyMceControlCollapse",
      this.collapse
    );
  }

  unbindListeners() {
    document.removeEventListener(
      "breakdanceTinyMceControlReady",
      this.onDialogReady
    );
    document.removeEventListener(
      "breakdanceTinyMceControlInput",
      this.onTinyMceControlInput as EventListener
    );
    document.removeEventListener("breakdanceTinyMceControlExpand", this.expand);
    document.removeEventListener(
      "breakdanceTinyMceControlCollapse",
      this.collapse
    );
  }

  onTinyMceControlInput(event: CustomEvent) {
    if (event.detail) {
      this.$emit("input", event.detail);
    }
  }

  onDialogReady() {
    this.loading = false;
    const iframe = this.$refs.iframe as HTMLIFrameElement;
    const message = {
      type: "breakdanceIframeMessage",
      value: this.value
    };
    const messageJson = pipe(
      fpJsonStringify(message),
      fold(
        () => "",
        result => result
      )
    );

    iframe?.contentWindow?.postMessage(messageJson);
  }

  expand() {
    this.expanded = true;
  }

  collapse() {
    this.expanded = false;
  }

  closeDialog() {
    this.$emit("close");
  }
}
